export enum Routes {
  WELCOME="/",
  TEAMS="/teams",
  GAMES="/games",
  SEAT="/seat",
  ENHANCED_GA_WHERE="/enhanced_ga_where",
  ENHANCED_GA_AREA="/enhanced_ga_area",
  ENHANCED_GA_MAP="/enhanced_ga_map",
  PLACE="/place",
  DETAILS="/details",
  MY_MOMENTS="/my_moments",
  MOMENT="/moment",
  ALL_MOMENTO="/all_momento",
  MOMENTO="/momento",
  EDITOR="/editor",
  DOWNLOAD_OPTIONS="/download_options",
  IMAGE="/image",
  SIGNUP="/signup",
  MOREINFO="/moreinfo",
  MOMENTO_OPTIONS="/options",
  PROFILE="/profile",
  PROFILE_GALLERY="/profile_gallery",
  VERIFY_SEAT="/verify_seat",
  OPT_OUT="/opt_out",
  COOKIE_SETTINGS="/cookie_settings",
  COOKIE_POLICY="/cookie_policy",
  TERMS_OF_USE="/terms_of_use",
  PRIVACY_POLICY="/privacy_policy",
}

export enum Params {
  ID="id",
  INDEX="index",
  FROM="from",
  MOMENT_INDEX="momentIndex",
  /** My Moments ticket tab when opening editor: Ticket1 | Ticket2 | Ticket3 */
  TICKET_REF="ticketRef",
}
